import { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import Highlights from "../Component/Highlights";
const Header = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <div className="header padded-sec">
        <div className="logo">
          <NavLink to="/">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/logo.png"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </NavLink>
        </div>
        <div className="header-nav">
          {/* <Highlights /> */}
          <div className="toplink">
            <ul className="toplinkmenu">
              <li><a href="#">Admission</a></li>
              <li><a href="#">Contact</a></li>
              <li><a href="#">Career</a></li>
            </ul>
            <div className="social-links">
              <a href="#" className="social-icon facebook">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#" className="social-icon instagram">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="#" className="social-icon linkedin">
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>
          <nav className="navbar navbar-expand-lg">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#main_nav"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="main_nav">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <NavLink className="dropdown-item" to="/">
                    Home
                  </NavLink>
                </li>

                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    About Us
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink className="dropdown-item" to="/about-us">
                        About School
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/school-song">
                        School Prayer & Song
                      </NavLink>
                    </li>
                    <li className="dropdown-submenu">
                      <NavLink className="dropdown-item" to="/">
                        Leadership
                      </NavLink>
                      <ul className="dropdown-menu fade-up">
                        <li>
                          <NavLink
                            className="dropdown-item"
                            to="/founder-inner"
                          >
                            Our Founder
                          </NavLink>
                        </li>
                        <li>
                          <NavLink className="dropdown-item" to="/chairman-message">
                            Chairman's Message
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className="dropdown-item"
                            to="/message/principal"
                          >
                            Principal's Message
                          </NavLink>
                        </li>
                        <li>
                          <NavLink className="dropdown-item" to="/headmistress-message">
                            Headmistress's Message
                          </NavLink>
                        </li>
                      </ul>
                    </li>

                    {/* <li><NavLink className="dropdown-item" to="/">Leadership</NavLink>
                      <ul className="dropdown-menu fade-up">
                        <li><NavLink className="dropdown-item" to="/">Our Founder</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/">Chairman</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/principal">Principal's Message</NavLink></li>
                        <li><NavLink className="dropdown-item" to="/">Headmistress</NavLink></li>
                      </ul>
                    </li>
                     */}
                    <li>
                      <NavLink className="dropdown-item" to="/BoardMembers">
                        Board Members
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/former-headmistress"
                      >
                        Former Headmistress
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/gallery">
                        Gallery
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/events">
                        Events
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    Academics
                  </div>
                  <ul className="dropdown-menu fade-up">
                    {/* <li><NavLink className="dropdown-item" to="/">Curriculum</NavLink></li> */}
                    <li>
                      <NavLink className="dropdown-item" to="/subjects-offered">
                        Subjects Offered
                      </NavLink>
                    </li>
                  </ul>
                </li>
                {/* <li className="nav-item">
                  <NavLink className="dropdown-item" to="/events">
                    Events
                  </NavLink>
                </li> */}
                {/* <li className="nav-item">
                  <NavLink className="dropdown-item" to="/admission">
                    Admission
                  </NavLink>
                </li> */}

                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    Facilities
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink className="dropdown-item" to="/computer-lab">
                        Computer Lab
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/physics-lab">
                        Physics Lab
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/chemistry-lab">
                        Chemistry Lab
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/biology-lab">
                        Biology Lab
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/library">
                        Library
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/school-choir">
                        School Choir
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/sports">
                        Sports
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/ai-robotics-lab">
                        AI & Robotics
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/school-hall">
                        School Hall
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/staff">
                        Teaching Staff
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/staff">
                        Administration Staff
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/infirmary">
                        Infirmary
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="dropdown-item"
                    to="https://portalguidelines.campuscare.info/index.html#FAJSBL"
                    target="_blank"
                  >
                    CampusCare
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="dropdown-item" to="/contact-us">
                    Contact Us
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink className="dropdown-item" to="/">
                    Career
                  </NavLink>
                </li> */}
                {/* 
                <li className="nav-item">
                  <NavLink className="dropdown-item" to="/">
                    Exams
                  </NavLink>
                </li> */}
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
